module.exports = __webpack_public_path__ + "static/shop-my-instagram-d-54fe42d1dc5ba94ae06e3395ca4ddcb1.jpg";